import { render, staticRenderFns } from "./startConfirmDialog.vue?vue&type=template&id=1c6085a6&scoped=true"
import script from "./startConfirmDialog.vue?vue&type=script&lang=js"
export * from "./startConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./startConfirmDialog.vue?vue&type=style&index=0&id=1c6085a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6085a6",
  null
  
)

export default component.exports